import API from 'utils/api';
import { onSuccess, onError } from 'utils/handlers';
import getFormattedValues, { formatReceived } from 'utils/formatValues';

export const baseURI = '/empresas/retenedor-de-nominas/';

/**
 * GET Nominas
 * @param {Object} params
 * @returns {Promise<Array<Object>>}
 */
export const getRetenedoresDeNominas = async (params = null) => {
  try {
    const response = await API.get(baseURI, { params });
    const output = { ...response.data, results: formatReceived(response.data.results) };
    return output;
  } catch (err) {
    onError(err);
    return { results: [] };
  }
};

/**
 * GET Nomina
 * @param {number} id
 * @returns {Promise<Object>}
 */
export const getRetenedorDeNomina = async (id) => {
  try {
    const response = await API.get(`${baseURI}${id}`);
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return null;
  }
};

/**
 * POST Nomina
  * @param {Object} values
 * @returns {Promise<Object>}
 */
export const postRetenedorDeNomina = async (values) => {
  try {
    const response = await API.post(baseURI, getFormattedValues(values));
    onSuccess(response, 'Agregado correctamente');
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Nomina
 * @param {number} id
 * @param {Object} values
 * @returns {Promise<Object>}
 */
export const patchRetenedorDeNomina = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}${id}`, getFormattedValues(values));
    onSuccess(response, 'Editado correctamente');
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Nomina
 * @param {number} id
 * @returns {Promise<Object>}
 */
export const deleteRetenedorDeNomina = async (id) => {
  try {
    const response = await API.delete(`${baseURI}${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 *  GET Horarios Nomina
 * @param {number} id
 * @returns Promise<Array<Object>>
 */
export const getHorariosRetenedorDeNomina = async (id) => {
  try {
    const response = await API.get(`${baseURI}${id}/horarios/`);
    return response.data;
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * GET nomina para la caja
 * @param {object} params
 * @returns {Promise<Array<Object>>}
 */
export const getRetenedorDeNominaCaja = async (params = null) => {
  try {
    const response = await API.get('/empresas/retenedor-de-nomina-caja/', { params });
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return [];
  }
};
